import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as selectors from 'store/alimentador/reducer';
import * as actions from 'store/alimentador/actions';
import DefaultSelectV2 from '../DefaultSelectV2';
import MultiSelectV2 from '../MultiSelectV2';

const AlimentadorSelectV2 = ({
  alimentadores,
  onSelect,
  value,
  isRequired,
  error,
  helperText,
  findOptions,
  useFilter,
  malhaId,
  gerenciaId,
  poloId,
  subestacaoId,
  disabled,
  multiSelect,
}) => {
  const handleChange = (event) => onSelect(event.target.value);
  const handleMultiplo = (newValue) => {
    let result = null;
    if (newValue) {
      result = newValue.map((v) => v.value);
    }
    onSelect(result);
  };

  const malhaKey = JSON.stringify(malhaId ?? null);
  const gerenciaKey = JSON.stringify(gerenciaId ?? null);
  const poloKey = JSON.stringify(poloId ?? null);
  const subestacaoKey = JSON.stringify(subestacaoId ?? null);
  useEffect(() => {
    if (useFilter) {
      findOptions({ malhaId, gerenciaId, poloId, subestacaoId });
    } else {
      findOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useFilter, findOptions, malhaKey, gerenciaKey, poloKey, subestacaoKey]);

  if (multiSelect) {
    return (
      <MultiSelectV2
        isRequired={isRequired}
        error={error}
        helperText={helperText}
        label="Alimentadores"
        onChange={(newValue) => handleMultiplo(newValue)}
        defaultValue={
          alimentadores && value
            ? alimentadores
                .filter((p) => value.indexOf(p.id) > -1)
                .map((i) => ({ value: i.id, label: `${i.codigo} - ${i.nome}` }))
            : []
        }
        options={
          alimentadores
            ? alimentadores.map((i) => ({ value: i.id, label: `${i.codigo} - ${i.nome}` }))
            : []
        }
        disabled={disabled}
      />
    );
  }

  return (
    <DefaultSelectV2
      error={error}
      helperText={helperText}
      isRequired={isRequired}
      label="Alimentador"
      onSelect={handleChange}
      options={alimentadores}
      value={value}
      disabled={disabled}
    />
  );
};

AlimentadorSelectV2.propTypes = {
  error: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  alimentadores: PropTypes.array.isRequired,
  helperText: PropTypes.string,
  isRequired: PropTypes.any,
  onSelect: PropTypes.func.isRequired,
  findOptions: PropTypes.func.isRequired,
  useFilter: PropTypes.bool,
  malhaId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  gerenciaId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  poloId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  subestacaoId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  multiSelect: PropTypes.bool,
};

AlimentadorSelectV2.defaultProps = {
  error: null,
  helperText: null,
  isRequired: false,
  useFilter: true,
  malhaId: null,
  gerenciaId: null,
  poloId: null,
  subestacaoId: null,
  disabled: false,
  multiSelect: false,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actions }, dispatch);
const mapStateToProps = (state) => ({
  alimentadores: selectors.getAlimentadoresOptions(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlimentadorSelectV2);
